import {
    feedbackEmail,
    contactUsEmail,
  } from "../../../utils/constantInformation";
export function setTime(time) {
    var date = new Date(time);

    return date.toLocaleString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
}
export const goToTerms = () => {
    window.location.href = "/terms";
};
export const goToPrivacy = () => {
    window.location.href = "/privacypolicy";
};
export function gotoExternalLink(link) {
    window.open(link);
}
export const goToFAQ = () => {
    const path = window.location.origin + "/#faq";
    window.open(path);
};

export function handleEmailClient(subject, ideas_flag) {
    let to_email = null;
    if (ideas_flag == true) {
        to_email = feedbackEmail;
    } else {
        to_email = contactUsEmail;
    }
    window.location.href = "mailto:" + to_email + "?subject=" + subject;
}